import * as React from 'react';
import {Helmet} from 'react-helmet';
import TeamInviteForm from '../../containers/TeamInviteForm';
import Card, {CardHeader, CardBody} from '../../components/Card';

export default class TeamInvite extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Invite your team members</title>
        </Helmet>
        <Card>
          <CardHeader>Invite your team members</CardHeader>
          <CardBody>
            <TeamInviteForm />
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/TeamInvite/TeamInvite.tsx